/** Normalize Mongo ObjectId / UUID strings so storefront filters match admin & API casing. */
export function normalizeIdForCompare(s) {
  const t = String(s ?? '').trim();
  if (!t) return '';
  if (/^[a-f\d]{24}$/i.test(t)) return t.toLowerCase();
  if (/^[a-f\d-]{36}$/i.test(t) || /^[a-f\d]{32}$/i.test(t)) return t.toLowerCase();
  return t.toLowerCase();
}

export function idsMatch(a, b) {
  return normalizeIdForCompare(a) === normalizeIdForCompare(b);
}

/**
 * Strict category match for storefront filters — avoids cross-category slug collisions.
 * Uses id, exact name, exact slug, or child slug under the same category slug (slug-child).
 */
export function productMatchesSelectedCategory(p, wantId, categories) {
  const selectedCategory = (categories || []).find((c) => idsMatch(c.id || c._id, wantId));
  const wantName = selectedCategory?.name?.trim().toLowerCase();
  const wantSlug = (selectedCategory?.slug || wantName?.replace(/\s+/g, '-') || '').toLowerCase();
  const catId = typeof p.category === 'object' && p.category ? (p.category._id || p.category.id) : (p.category || p.categoryId);
  if (catId != null && idsMatch(catId, wantId)) return true;
  if (wantName && (p.categoryName || '').toLowerCase() === wantName) return true;
  const pSlug = (p.categorySlug || (p.categoryName || '').toLowerCase().replace(/\s+/g, '-')).toLowerCase();
  if (wantSlug && pSlug === wantSlug) return true;
  if (wantSlug && pSlug.startsWith(`${wantSlug}-`)) return true;
  return false;
}
